(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldTimepicker', activitiesFieldTimepicker);

    function activitiesFieldTimepicker(lodash) {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                element: '=',
            },
            templateUrl: 'common/app/components/activities/activity-input/fields/timepicker',
            link: function (scope, elem, attr, ctrl) {
                console.log('timepicker', elem);
                var timepickerObj = elem.find('.time input');
                var timeOptions =  angular.extend(
                    {
                        'showDuration': true,
                        'timeFormat': 'g:i a',

                        // 'minTime': '2:00pm',
                    },
                    lodash.get(scope.element, 'options', {})
                );
                scope.selected_time = null;

                timepickerObj.timepicker(timeOptions);

                ctrl.$render = function() {
                    scope.selected_time = ctrl.$viewValue;
                }

                timepickerObj.on('changeTime', function() {
                    // $('#onselectTarget').text($(this).val());
                    ctrl.$setViewValue(scope.selected_time);
                });

                // scope.$watch('selected_time', function() {
                //     console.log('selected_time watch', scope.selected_time);
                //     ctrl.$setViewValue(scope.selected_time);
                // })
            }
        };
    }
})();
